import { Component, Input, NgZone, ElementRef } from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map'
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { httpService } from '../service/servicio'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-modelos',
  templateUrl: './modelos.component.html',
  styleUrls: ['./modelos.component.css']
})
export class ModelosComponent {


      constructor (private http: httpService,  public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

          this.toastr.setRootViewContainerRef(vcr);
           ("en Modelos-..");
          this.tituloModelo = 'Modelos ';
          this.descargarModelos();
          this.orden(2);

        };


        uploaded = {
          Status:0,
          Text:''

        }

        @Input() modelos: any = [];

        tituloModelo:string =  '';
        modeloSearch: string ='';
        place:string = 'Buscar por Modelo';
        sort: string = 'modelo';
        mostrarDatosModelo:boolean = false;

        orden(n) {
          if (n == 1) { this.sort='Id'; this.place='Buscar por Id' };
          if (n == 2) { this.sort='modelo'; this.place='Buscar por Modelo' };
        }

       quitarfiltro(tipo: Number) {
          this.modeloSearch = '';
       }

      filtro() {

          return this.modelos.filter((modelo) => {
            if (this.sort == 'Id')
               return modelo.Id.toLowerCase().indexOf(this.modeloSearch.toLowerCase()) != -1;
            if (this.sort == 'modelo')
               return modelo.modelo.toLowerCase().indexOf(this.modeloSearch.toLowerCase()) != -1;

           });
      }


      descargarModelos() {

              this.http.descargarModelos()
                      .subscribe(modelo => {
                           this.modelos = modelo;

                      }, err => {

                      }, () => {
                        if (this.modelos == null) {

                            this.toastr.warning("No existen modelos", "Modelos");

                        }


               });
            }


      pulsado(modelo) {
          this.http.modeloGrabar = modelo;

          this.mostrarDatosModelo = true;
      }

      crearModelo() {

         this.http.modeloGrabar = this.http.nuevoModelo();


         this.mostrarDatosModelo = true;
      }



      volver() {

        this.http.sw.mostrarmodelos = true;
        this.toastr.warning("Cargando Datos...", "Internet");

      }

      cancelar() {
          this.http.descargarModelos().subscribe(respuesta => {
          this.modelos = respuesta;
          this.mostrarDatosModelo = false;
        });

      }

      borrarpulsado(modelo) {

        this.http.modeloGrabar = modelo;
      }

      borrar(){

          this.http.datosPost.action = 2; // borrar
          this.http.datosPost.datos = this.http.modeloGrabar;
          this.http.modelo(this.http.datosPost).subscribe(respuesta => {
                this.http.uploaded = respuesta;

            }, err => {

            }, () => {
                if (this.http.uploaded.Status == 1) {
                      this.toastr.success(this.http.uploaded.Text,'Modelos');
                      this.http.descargarModelos().subscribe(respuesta => {
                        this.modelos =respuesta;
                    });
                }else{

                    this.toastr.error(this.http.uploaded.Text,'Tarifas');
                }
          });

      }


      grabar() {
        this.http.datosPost.action = 1; // por defecto Update
        if (this.http.modeloGrabar.Id == 0) this.http.datosPost.action = 0; // si es nueva Insert;
          this.http.datosPost.datos = this.http.modeloGrabar;
          this.http.modelo(this.http.datosPost).subscribe(respuesta => {
              this.http.uploaded = respuesta;

            }, err => {
                
            }, () => {
              if (this.http.uploaded.Status == 1) {
                  this.toastr.success(this.http.uploaded.Text,'Modelo');
                  this.http.descargarModelos().subscribe(respuesta => {
                    this.modelos = respuesta;
                    this.mostrarDatosModelo = false;
                  });
              }else{
                  this.toastr.error(this.http.uploaded.Text,'Modelo');
              }
        });

      }



}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/modelos/modelos.component.ts